<template>
  <v-container>
    <v-row v-if="value.title || value.paragraphs" justify="center">
      <v-col cols="12">
        <TitleParagraphBlock
          :value="{
            paragraphs: value.paragraphs,
            title: value.title
              ? value.title
              : `About ${course.abbreviated_name || course.name}`
          }"
          title-center
        />
      </v-col>
    </v-row>

    <v-row v-if="value.video" justify="center">
      <v-col cols="12" lg="8" xl="6">
        <VideoCover
          :aspect-ratio="videoAspectRatio"
          :gradient="COURSE_INTRO_VIDEO_GRADIENT"
          :value="value.video"
          content-class="d-flex align-center justify-center"
          max-height="800"
          style="position: relative"
        >
          <PlayVideo :title="value.video.title" :video="value.video" />
        </VideoCover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { COURSE_INTRO_VIDEO_GRADIENT } from '#root/lib/consts'

defineProps({
  course: {
    required: true,
    type: Object
  },
  value: {
    required: true,
    type: Object
  }
})

const videoAspectRatio = 8 / 5
</script>
